import React from 'react';
import {
  ViewOptionsSectionEntry,
  ViewOptionsSectionId,
} from 'shared/types/view-options-section';

import { CalendarAccountSection } from '../calendar-account-section';
import { LifeAreasSection } from '../life-areas-section';
import { ShowSection } from '../show-section';

export type ViewOptionsSectionProps = {
  section: ViewOptionsSectionEntry;
  isFirst?: boolean;
};

export const ViewOptionsSection: React.FC<ViewOptionsSectionProps> = ({
  section,
  isFirst,
}) => {
  if (section.account) {
    return (
      <CalendarAccountSection account={section.account} isFirst={isFirst} />
    );
  }

  if (section.id === ViewOptionsSectionId.LifeAreas) {
    return <LifeAreasSection isFirst={isFirst} />;
  }

  return <ShowSection isFirst={isFirst} />;
};
